export class ConfigEnviroment {
    production?: boolean;
    envName?: string;
    value?: string;
    apiEndpoint?: string;
    apiEndpointClient?: string;
    titulo?: string;
}
